import React, { useState, useEffect } from "react";
import logo from "./logo/logo_transparent.png"; // Tell webpack this JS file uses this image
import {
  MenuItem,
  FormControl,
  Select,
  Card,
  CardContent,
} from "@material-ui/core";
import "./App.css";
import InfoBox from "./InfoBox";
import Map from "./Map";
import Table from "./Table";
import { sortData, prettyPrintStat } from "./util";
import LineGraph from "./LineGraph";
import "leaflet/dist/leaflet.css";
/* // BEM naming convention */

function App() {
  const [countries, setCountries] = useState([]);
  const [country, setCountry] = useState(["worldwide"]);
  //here we are adding another piece of state for our data
  //we are pulling per individual country. Hence the curly braces in the useState.
  const [countryInfo, setCountryInfo] = useState({});
  const [tableData, setTableData] = useState([]);
  const [mapCenter, setMapCenter] = useState({ lat: 34.80746, lng: -40.4796 });
  const [mapZoom, setMapZoom] = useState(3);
  const [mapCountries, setMapCountries] = useState([]);
  const [casesType, setCasesType] = useState("cases");
  // STATE is how to write variables in REACT

  //https://disease.sh/v3/covid-19/countries
  //USEEFFECT = Runs a piece of code bases on a given condition
  //This useEffect will help in executing that call on the first load so you will already have data loaded
  //on the tracker dashboard when you go to the website. Because we set the url to ../all it is
  //getting the data for all the countries and our default option is worldwide so this works.
  useEffect(() => {
    fetch("https://disease.sh/v3/covid-19/all")
      .then((response) => response.json())
      .then((data) => {
        setCountryInfo(data);
      });
  }, []);

  useEffect(() => {
    //The code inside here will run once
    //once the App component loads on the screen =function App, a useEffect is essentially saying, fire off this piece of code once.
    // Any time the list of countries change, it will refire this code.
    // when the components load and not again
    // async ->send a request, wait for it, do something with info
    const getCountriesData = async () => {
      await fetch("https://disease.sh/v3/covid-19/countries")
        //when it comes back with the response then... I want to first get the entire response
        // and just get the json from it.
        // once we have the data back, we want to restructure it. We don't want the whole tree.
        .then((response) => response.json())
        .then((data) => {
          //the map function is loopintg through the list of countries, it gets the time and
          //returns the object and gives it a name and value here and will go to the next item
          //and it will loop through again and to the same thing until it goes through is no item to loop through
          const countries = data.map((country) => ({
            name: country.country, // United States, United Kingdom
            value: country.countryInfo.iso2, // UK, USA, FR
          }));

          const sortedData = sortData(data);
          setTableData(sortedData);
          setMapCountries(data);
          setCountries(countries);
        });
    };

    getCountriesData();
  }, []); //it will run as well whenever the countries variable changes.

  //it takes an event  everytime you click that dropdown, wa ant to get the countrycode of the selected.
  // This is going to grab the selected value.
  //you can test it with console.log
  //async will be used soon. But not now!!
  const onCountryChange = async (event) => {
    const countryCode = event.target.value;
    setCountry(countryCode);

    //test this code:
    // console.log("YOOO >>>>>", countryCode);

    //We want to get and the worlddwide stats and per country. We need a simple condition to check
    // when the countryCode is worldwide use the first link and when the countryCode is from one of the countries,
    // use the other link. We are going to use a ternary operator for this
    // https://dosease.sh/v3/covid-19/all
    // https://disease.sh/v3/covid-19/countries/[COUNTRY_CODE]
    const url =
      countryCode == "worldwide"
        ? "https://disease.sh/v3/covid-19/all"
        : //add a backtick to allow us to use javascript like below after the dollarsign
          `https://disease.sh/v3/covid-19/countries/${countryCode}`;

    await fetch(url)
      .then((response) => response.json())
      .then((data) => {
        setCountry(countryCode); //it is going to update the inputfield
        setCountryInfo(data);

        setMapCenter([data.countryInfo.lat, data.countryInfo.long]);
        setMapZoom(4);

        //it is storing the whole data you can test it by testing queries on the disease.sh website
      });
  };
  //Let us test const url and see if we can pull in the data when we select a country
  // console.log("COUNTRY INFO >>>", countryInfo);

  return (
    <div className="app">
      {/* // **********ADD OUTSIDE CONTAINER FOR THE LEFT SECTION OF OUR
        COVID TRACKER APP CONTAINING HEADER MAP AND INFOBOXES*************
       ******************************************************************/}
      <div className="app__left">
        {/* // **********START OF HEADER SECTION  + DROPDOWN****************
         *******************************************************************/}

        {/* Header  */}
        {/* Title = Select input dropdown field  */}

        <div className="app__header">
          <div class="logo">
            <img src={logo} />
          </div>
          <h1>COVID-19 TRACKER</h1>

          <FormControl className="app__dropdown">
            <Select
              variant="outlined"
              onChange={onCountryChange}
              value={country}
            >
              {/* Loop through all the countries and show
          a dropdown list of the options */}
              <MenuItem value="worldwide">Worldwide</MenuItem>
              {countries.map((country) => (
                <MenuItem value={country.value}>{country.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </div>

        {/* // **********END OF HEADER SECTION  + DROPDOWN*****************************************************
         ******************************************************************************************************* */}

        {/* // **********START OF INFOBOX SECTION  + DROPDOWN*****************************************************
         ******************************************************************************************************* */}

        <div className="app__stats">
          {/* to add on_click attribute so that when you click on the infobox card
           */}
          {/* Here when I click the first one I want to set it to case,
           When I click the second one set it to recovered,etc... */}
          <InfoBox
            isRed
            // If casesType is equal to cases, then this box is Active
            active={casesType === "cases"}
            onClick={(e) => setCasesType("cases")}
            title="Coronavirus cases"
            cases={prettyPrintStat(countryInfo.todayCases)}
            total={prettyPrintStat(countryInfo.cases)}
          />
          <InfoBox
            isGreen
            active={casesType === "recovered"}
            onClick={(e) => setCasesType("recovered")}
            title="Recovered"
            cases={prettyPrintStat(countryInfo.todayRecovered)}
            total={prettyPrintStat(countryInfo.recovered)}
          />
          <InfoBox
            isRed
            active={casesType === "deaths"}
            onClick={(e) => setCasesType("deaths")}
            title="Deaths"
            cases={prettyPrintStat(countryInfo.todayDeaths)}
            total={prettyPrintStat(countryInfo.deaths)}
          />
        </div>

        {/* Map */}
        <Map
          casesType={casesType}
          countries={mapCountries}
          center={mapCenter}
          zoom={mapZoom}
        />
      </div>
      <Card className="app__right">
        <CardContent>
          <h3>Live cases by country</h3>
          {/* Table */}
          <Table countries={tableData} />

          <h3 className="app__graphtitle">Worldwide new {casesType}</h3>
          {/* Graph  */}
          <LineGraph className="app__graph" casesType={casesType} />
        </CardContent>
      </Card>
    </div>
  );
}

export default App;
